import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DataStateChangeEventArgs, FilterSettingsModel, GridComponent, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DateService } from 'src/app/date.service';
import { GlobalComponent } from 'src/app/global/global.component';
import { ClientBirthDayReportBo, getClientReportBo } from './client-report.modal';
import { ColumnChangeBO, columnWidth } from '../icd10/icd10.model';
import * as pbi from 'powerbi-client';
import { IMyDpOptions } from 'mydatepicker';
// import { ConfigurationService } from 'src/app/configuration.service';
import { CommonApiService } from 'src/app/commonapiservice';
import { EnvironmentService } from 'src/app/environment.service';
import { GetSDPReportBO, GetServicePlanBO } from '../serviceplan/serviceplan.model';
import { SDPService } from './client-report-services';
@Component({
  selector: 'app-client-report',
  templateUrl: './client-report.component.html',
  styleUrls: ['./client-report.component.scss']
})
export class ClientReportComponent implements OnInit {
  BirthDayReport: ClientBirthDayReportBo = new ClientBirthDayReportBo();
  @ViewChild('gridClientReport') public gridClientReport: GridComponent;
  @ViewChild('sdpReportGrid') public sdpReportGrid: GridComponent; 
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  private onDestroy$: Subject<void> = new Subject<void>();
  public data: Observable<DataStateChangeEventArgs>;
  public sdpData: Observable<DataStateChangeEventArgs>;
  public formatOptions: object;
  isClientReportInactive:boolean=false;
  id: string = '00000000-0000-0000-0000-000000000000';
  datalength: number = 0;
  ClientStatusList: any = [];
  QpEmployeeDropDown: any = [];
  genderList: any = [];
  TypeofWaiver: any = [];
  TypeofClient: any = [];
  PcaTypeList: any = [];
  AssessmentingRatingList: any = [];
  filterOptions: FilterSettingsModel;
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  ReportList: getClientReportBo = new getClientReportBo()
  locationId: any = '00000000-0000-0000-0000-000000000000';
  @ViewChild("reportContainer", { static: false }) reportContainer: ElementRef;
  initialPage: object;
  clienttypeLid: any;
  genderLid: any;
  ViewReport: boolean = false;
  height: string = "200px";
  employeeId: any;
  pCATypeLid: any;
  typeofWaiverLid: any;
  assessmentRatingLid: any;
  ReportstatusLid: any;
  isEnabledExcel: boolean = false;
  isEnabledPrint: boolean = false;
  ColumnArray: columnWidth[];
  ClientReportList: any = [];
  arraycol: any = [];
  ValidationDate: any;
  ClientReportDropData: string[] = [];
  clientReportFilterList: [{ label: string, value: string }];
  date: Date;
  reptitle: any = '';
  StatusLst: any;
  CaseStatus: any;
  environmentServicedata:any;
    // SDP Report Properties
  isSDPReportActive: boolean = false;
  reportFromDate: string = '';
  reportToDate: string = '';
  SDPReportList: any[] = [];
  sdpReportData: Observable<DataStateChangeEventArgs>;
  reportInitialPage: PageSettingsModel;
  sdpReportListSendBO: GetServicePlanBO = new GetServicePlanBO();
    GetSDPReportBO: GetSDPReportBO = new GetSDPReportBO();
  sdpPdfSrc: any;
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    //disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 },
    showClearDateBtn: true,
    editableDateField: true
  };
  maxDateRangeDays: any;
  FilterStartDate: any = "";
  FilterEndDate: any = ""
  constructor(public CommonAPI: CommonApiService,public SDPAPI: SDPService, 
    // public configurationservice: ConfigurationService, 
    public environmentService: EnvironmentService,
    private cdr: ChangeDetectorRef, 
    private router: Router, 
    public dateservice: DateService, 
    public global: GlobalComponent, 
    public toastrService: ToastrService,
    public datepipe: DatePipe,) {
    this.data = CommonAPI;
    this.sdpData = SDPAPI;
    this.environmentServicedata = this.environmentService.getEnvironmentsConfiguration();

  }
  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }
  ngOnInit(): void {
    if (
      this.global.globalAgencyId == null ||
      this.global.globalAgencyId == "" ||
      this.global.globalAgencyId == undefined ||
      this.global.globalAgencyId == '00000000-0000-0000-0000-000000000000'
    ) {
      return;
    }
    if (this.global.globalLocationId == null || this.global.globalLocationId == undefined || this.global.globalLocationId == '') {
      this.locationId = '00000000-0000-0000-0000-000000000000';
    }
    else {
      this.locationId = this.global.globalLocationId;
    }
    if (this.global.globalAgencyId != '00000000-0000-0000-0000-000000000000') {
      this.getQpEmployeeDropDown();
      this.getGender();
      this.getstatus();
      this.getClientTypeLid();
      this.getTypeofwaiver(); 
      this.FilterStartDate = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
    this.FilterEndDate = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();     
    }
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };
    this.filterOptions = { type: 'Menu' };
    let pag = null
    if (this.global.globalColumn != null && this.global.globalColumn != undefined && this.global.globalColumn != "") {
      pag = JSON.parse(this.global.globalColumn.column)[0].Clientreport.Pagesize;
      this.ReportList.pageitem = pag;
    }
    else {
      pag = 10;
    }
    this.reportInitialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: pag, pageSize: pag, pageSizes: this.pageSizes };
    
  }
  
  show() {
    this.gridClientReport.columnChooserModule.openColumnChooser(200, 50);
  }
  refreshToGetDropDownValues(ListCode: string) {
    if (this.global.globalAgencyId != '00000000-0000-0000-0000-000000000000') {
      let url = "api/LOV/getLovDropDown?"
      let params = new URLSearchParams();
      params.append("ListCode", ListCode);
      this.CommonAPI.RefreshDropDownList(ListCode,params, url, "LovDropDown").then((data: any) => {
        
        if (ListCode == 'STATUS') {
          this.ClientStatusList = data;
          this.ClientStatusList.forEach(element => {
            element.id = element.id;
          });
        }
        
        if (ListCode == 'GENDER') {
          this.genderList = data?.filter(ele=>ele.lovCode?.toUpperCase()!='OTHERS');
          this.genderList.forEach(element => {
            element.id = element.id;
          })
        }
        if (ListCode == 'CLIENTTYPE') {
          this.TypeofClient = data;
          this.TypeofClient.forEach(element => {
            element.Key = element.Key.toString();
          })
        }
        // if (ListCode == 'PCATYPE') {
        //   this.PcaTypeList = data;
        //   this.PcaTypeList.forEach(element => {
        //     element.Key = element.Key.toString();
        //   })
        // }
        if (ListCode == 'TYPEOFWAIVER') {
          this.TypeofWaiver = data;
          this.TypeofWaiver.forEach(element => {
            element.Key = element.Key.toString();
          });
        }
      })
    }
  }
  getClientTypeLid() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", "CLIENTTYPE");
    this.CommonAPI.getDropDownList('CLIENTTYPE',params, url, "LovDropDown").then((data: any) => {
      this.TypeofClient = data;
      this.TypeofClient.forEach(element => {
        element.id = element.id.toString();
      })
    },
      (err: any) => {
        this.toastrService.error(err);
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      }
    )
  }
  // getAssessmentingRating() {
  //   let url = "api/LOV/getLovDropDown?"
  //   let params = new URLSearchParams();
  //   params.append("Code", "ASSESSMENTRATING");
  //   this.CommonAPI.getDropDownList('ASSESSMENTRATING',params, url, "LovDropDown").then((data: any) => {
  //     this.AssessmentingRatingList = data;
  //     this.AssessmentingRatingList.forEach(element => {
  //       element.Key = element.Key.toString();
  //     })
  //   },
  //     (err: any) => {
  //       this.toastrService.error(err);
  //       setTimeout(() => {
  //         this.toastrService.clear();
  //       }, 8000);
  //     }
  //   )
  // }
  getstatus() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", "STATUS");
    this.CommonAPI.getDropDownList('STATUS',params, url, "LovDropDown").then((data: any) => {
      this.ClientStatusList = data;
      this.ClientStatusList.forEach(element => {
        element.id = element.id;
      });
      this.ClientReportDropData = data.map(e => e.Value);
      this.ClientStatusList.push({ lovVaule: 'All', lovName: "All" });
      this.ReportstatusLid = this.ClientStatusList.filter(st => st.lovName == "Active")[0].id;
      this.ReportList.statusLid = this.ReportstatusLid.toString();
      this.ReportList.statusLid = (this.ReportstatusLid)
      this.getClientreportFilter();
    },
      (err: any) => {
        this.toastrService.error(err);
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      }
    )
  }
 
  getGender() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", "GENDER");
    this.CommonAPI.getDropDownList('GENDER',params, url, "LovDropDown").then((data: any) => {
      this.genderList = data?.filter(ele=>ele.lovCode?.toUpperCase()!='OTHERS');
      this.genderList.forEach(element => {
        element.id = element.id;
      })
    },
      (err: any) => {
        this.toastrService.error(err);
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      }
    )
  }
  
  getQpEmployeeDropDown() {
    let params = new URLSearchParams();
    // params.append("employeeId", emptype.toString());
    // params.append("LocationId", this.locationId);
    let url = "api/Employee/employeeDropDown?"
    this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.QpEmployeeDropDown = data;
      this.QpEmployeeDropDown.forEach(element => {
        element.Key = element.Key;
      })
    },
      (err: any) => {
        this.toastrService.error(err);
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      }
    )
  }
  getTypeofwaiver() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", "TYPEOFWAIVER");
    this.CommonAPI.getDropDownList('TYPEOFWAIVER',params, url, "LovDropDown").then((data: any) => {
      this.TypeofWaiver = data;
      this.TypeofWaiver.forEach(element => {
        element.id = element.id;
      })
    },
      (err: any) => {
        this.toastrService.error(err);
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      }
    )
  }
 
  ApplyFilter() {
    this.ReportList.clientTypeLid = (this.clienttypeLid ?? "") == "" ? "00000000-0000-0000-0000-000000000000" : (this.clienttypeLid);
    this.ReportList.genderLid = (this.genderLid ?? "") == "" ? "00000000-0000-0000-0000-000000000000" : (this.genderLid);
    
    this.ReportList.employeeId = (this.employeeId ?? "") == "" ? "00000000-0000-0000-0000-000000000000" : (this.employeeId);
    
    this.ReportList.statusLid = (this.ReportstatusLid ?? "") == "" ? "00000000-0000-0000-0000-000000000000" : (this.ReportstatusLid);
    this.ReportList.typeofWaiverLid = (this.typeofWaiverLid ?? "") == "" ? "00000000-0000-0000-0000-000000000000" : (this.typeofWaiverLid);
    this.getClientreportFilter();
  }
  RefreshFilter() {
    this.ReportList = new getClientReportBo();
    this.clienttypeLid = null;
    
    this.genderLid = null;
    this.employeeId = null;
    
    this.ReportList.currentpageno = 1;
    this.gridClientReport.pageSettings.currentPage = 1;
    this.ReportList.pageitem = this.gridClientReport.pageSettings.pageSize;
    this.ReportstatusLid = this.ClientStatusList.filter(st => st.lovName == "Active")[0].id;
    this.ReportList.statusLid = (this.ReportstatusLid ?? "") == "" ? "00000000-0000-0000-0000-000000000000" : (this.ReportstatusLid);
    this.getClientreportFilter();
    this.gridClientReport.clearFiltering();
    this.gridClientReport.clearSorting();
  }
  ClearFilter() {
    this.ReportstatusLid = this.ClientStatusList.filter(st => st.lovName == "Active")[0].id;
    this.ReportList.statusLid = (this.ReportstatusLid ?? "") == "" ? "00000000-0000-0000-0000-000000000000" : (this.ReportstatusLid);
    this.ReportList.clientTypeLid = "00000000-0000-0000-0000-000000000000";
    
    this.ReportList.genderLid = "00000000-0000-0000-0000-000000000000";
    this.ReportList.employeeId = "00000000-0000-0000-0000-000000000000";
   
    this.clienttypeLid = null;
    this.pCATypeLid = null;
    this.genderLid = null;
    this.employeeId = null;
    this.assessmentRatingLid = null;
    this.typeofWaiverLid = null;
    this.getClientreportFilter();
  }
  getClientreportFilter() {
    // this.ReportList.locationID = this.locationId;
    let responseData =
    {
      result: "result",
      count: "count",
    }
    let url = "api/Client/getClientReport"
    this.CommonAPI.outputValues(url, this.ReportList, responseData, "");
    let count = 0;
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.ClientReportList = data.result;
      count = count + 1;
      this.datalength = data.Count;
      if (data != null && data != undefined && count == 1) {
       
      }
      if ((data != null && data.result.length > 0)) {
        this.isEnabledExcel = true;
        this.isEnabledPrint = true;

      }
      else {
        this.isEnabledExcel = false;
        this.isEnabledPrint = false;

      }
      if (data != null && data.result.length > 15) {
        this.gridClientReport.height = '500';
      }
      else {
        this.gridClientReport.height = 'auto';
      }

    })
  }
  public onSDPReportActionComplete(args) {
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.sdpReportGrid.columns.forEach(element => {
        if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
          hidearr.push(element.headerText);
        }
        if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
          showarr.push(element.headerText);
        }
      })
      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {
        if (this.arraycol.length > 0) {
          this.arraycol[0].Clientreport.ShowColumns.forEach(old => {
            showarr.forEach(element => {
              if (old == element) {
                count1 = count1 + 1;
              }
            });
          });
          this.arraycol[0].Clientreport.HideColumns.forEach(old => {
            hidearr.forEach(element => {
              if (old == element) {
                count = count + 1;
              }
            });
          });
          if (this.arraycol[0].Clientreport.ShowColumns.length != count1 || this.arraycol[0].Clientreport.HideColumns.length != count) {
            this.arraycol[0].Clientreport.ShowColumns = showarr;
            this.arraycol[0].Clientreport.HideColumns = hidearr;
            this.arraycol[0].Clientreport.Pagesize = this.gridClientReport.pagerModule.pagerObj.pageSize
           
          }
        }
      }
    }
    this.GetSDPReportBO.currentpageno = this.sdpReportGrid.pagerModule.pagerObj.currentPage;
    this.GetSDPReportBO.pageitem = this.sdpReportGrid.pagerModule.pagerObj.pageSize;
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.GetSDPReportBO.type = args.columnType
    }
  }
  public sdpReportDataStateChange(state): void {
    let type = (state.action.requestType).toString();

    this.GetSDPReportBO.currentpageno = this.sdpReportGrid.pagerModule.pagerObj.currentPage;
  this.GetSDPReportBO.pageitem = this.sdpReportGrid.pagerModule.pagerObj.pageSize;
    if (type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.GetSDPReportBO.orderColumn = state.sorted[0].name;
        this.GetSDPReportBO.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (type == "filtering" && state.action.action != "clearFilter") {
       this.GetSDPReportBO.currentpageno = 1;
      this.GetSDPReportBO.pageitem = 10;
      if (this.GetSDPReportBO.type == "number") {
        this.GetSDPReportBO.value = state.action.currentFilterObject.value.toString();
        this.GetSDPReportBO.field = state.action.currentFilterObject.field;
      }
      if (this.GetSDPReportBO.type == "date") {
        this.GetSDPReportBO.value = (new Date(new Date(state.action.currentFilterObject.value).toLocaleDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "");
        this.GetSDPReportBO.field = state.action.currentFilterObject.field;
      }
      else if (this.GetSDPReportBO.type == "number") {
        this.GetSDPReportBO.value = state.action.currentFilterObject.value.toString();
        this.GetSDPReportBO.field = state.action.currentFilterObject.field;
      }
      else {
        this.GetSDPReportBO.value = state.action.currentFilterObject.value;
        this.GetSDPReportBO.field = state.action.currentFilterObject.field;
      }

      this.GetSDPReportBO.matchCase = state.action.currentFilterObject.matchCase;
      this.GetSDPReportBO.operator = state.action.currentFilterObject.operator;
    }
    else {
      if (type == "filtering" && state.action.action == "clearFilter") {
        this.GetSDPReportBO.currentpageno = 1;
       this.GetSDPReportBO.pageitem = 10;
        this.GetSDPReportBO.field = "clientName";
        this.GetSDPReportBO.matchCase = false;
        this.GetSDPReportBO.operator = "contains";
        this.GetSDPReportBO.value = "";
        this.GetSDPReportBO.type = "string"
      }
    }
    this.getSDPReportList();
    if (type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].sdpReportData.Pagesize != state.take) {
          this.arraycol[0].sdpReportData.Pagesize = state.take
          
        }
      }
    }
  }
 
  onResize(args) {
    if (this.ColumnArray != undefined && this.ColumnArray != null) {
      const column = this.gridClientReport.getColumnByField(args.column.field)
      column.width = args.column.width;
      this.ColumnArray.forEach(element => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });
      
    }
  }
  MovetoClientParent() {
    this.router.navigateByUrl('/Client');
  }
  exportClientReportCsv() {
    let url = "api/Client/exportClientReportCsv";
    this.CommonAPI.saveorUpdateFunctionFileSaver(this.ReportList, url, "ClientReport.csv");
  }
  getClientBirthdayReport() {
    // let currentTime = this.datepipe.transform(new Date(), "MM/dd/yyyy hh:mm a");
    // let embedUrl = "";
    // this.reptitle = "Client BirthDay Report";
    // var startDate = this.BirthDayReport.fromDate != null && this.BirthDayReport.fromDate != undefined && this.BirthDayReport.fromDate != "" ?
    //   this.global.getDateTimeString(this.BirthDayReport.fromDate)
    //   : null;
    // var endDate = this.BirthDayReport.endDate != null && this.BirthDayReport.endDate != undefined && this.BirthDayReport.endDate != "" ?
    //   this.global.getDateTimeString(this.BirthDayReport.endDate) : null;
    // embedUrl = "https://app.powerbi.com/rdlEmbed?reportId=" + this.configurationservice.configuration.ClientBirthDayReportId +
    //   "&rp:agencyid=" + this.global.globalAgencyId + "&rp:startdate=" + startDate + "&rp:enddate="
    //   + endDate + "&rp:locationid=" + this.locationId + "&rp:ExecTime=" + currentTime +
    //   "&rdl:parameterPanel=hidden";

    // this.ViewReport = true;
    // this.CommonAPI.CommonFunctionforPowerBiToken().then((token) => {
    //   document.getElementById('OpenCBirthDayModal').click();
    //   let embedReportId = this.configurationservice.configuration.ClientBirthDayReportId;
    //   let config = {
    //     type: 'report',
    //     tokenType: pbi.models.TokenType.Aad,
    //     accessToken: token[0],
    //     embedUrl: embedUrl,
    //     id: embedReportId,
    //     settings: {},
    //     viewmode: pbi.models.ViewMode.View
    //   };
    //   let reportContainer = this.reportContainer.nativeElement;
    //   let powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
    //   let report = powerbi.embed(reportContainer, config);
    //   report.off("loaded");
    //   report.on("loaded", () => {
    //   });
    // });

  }
  BirthDayReportDateChanges(event, type, name) {
    if (type == "inputchange") {
      if (name == 'BirthDayfromDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.BirthDayReport.fromDate = val1;
        }
      }
      if (name == 'BirthDayEndDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.BirthDayReport.endDate = val1;
        }
      }
    }
    if (type == "datechanged") {
      if (name == 'BirthDayfromDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.BirthDayReport.fromDate = val1;

          var StartDate = new Date(this.BirthDayReport.fromDate);
          let setDate = StartDate.setDate(StartDate.getDate() + 365);
          let getDate = setDate;
          this.ValidationDate = this.datepipe.transform(getDate, "MM/dd/yyyy");
          this.clearEndTimeValidation();
        }
      }
      if (name == 'BirthDayEndDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.BirthDayReport.endDate = val1;
          this.clearEndTimeValidation();
        }
      }
    }
  }
  clearEndTimeValidation() {
    if (this.BirthDayReport.fromDate != null && this.BirthDayReport.fromDate != undefined && this.BirthDayReport.fromDate != '' &&
      this.BirthDayReport.endDate != null && this.BirthDayReport.endDate != undefined && this.BirthDayReport.endDate != '') {

      let EndDate = this.datepipe.transform(this.BirthDayReport.endDate, "MM/dd/yyyy");

      if (new Date(EndDate).getTime() > new Date(this.ValidationDate).getTime()) {
        this.toastrService.error("Date range should not be greater than 1 year");
        this.BirthDayReport.endDate = null;

        setTimeout(() => {
          this.toastrService.clear();
        }, 3000);

      }
      if (this.BirthDayReport.endDate != null && this.BirthDayReport.endDate != undefined && this.BirthDayReport.endDate != '') {

        if (new Date(this.BirthDayReport.fromDate).getTime() > new Date(this.BirthDayReport.endDate).getTime()) {
          this.BirthDayReport.endDate = null;
          this.toastrService.error("end time should greater than start time");
          setTimeout(() => {
            this.toastrService.clear();
          }, 3000);
          return;
        }
      }
    }
  }
  clearModal() {
    this.BirthDayReport = new ClientBirthDayReportBo();
  }
  closeGenerateModal() {
    this.ViewReport = false;

    document.getElementById('OpenCBirthDayModal').click();
  }
  generateRpReport() {
    let currentTime = this.datepipe.transform(new Date(), "MM/dd/yyyy hh:mm a");
    this.ViewReport = true;
    this.reptitle = "RP Report";
    this.CommonAPI.CommonFunctionforPowerBiToken().then((token) => {
      document.getElementById("OpenCBirthDayModal").click();
      // let embedUrl =
      //   "https://app.powerbi.com/rdlEmbed?reportId=" +
      //   this.configurationservice.configuration.RPReportId +
        "&rp:ExecTime=" +
        currentTime +
        "&rp:agencyid=" +
        this.global.globalAgencyId +
        "&rp:locationid=" +
        ((this.locationId != null && this.locationId != undefined && this.locationId != '') ? this.locationId : '00000000-0000-0000-0000-000000000000') +
        "&rp:userid=" +
        ((this.global.userID != null && this.global.userID != undefined && this.global.userID != '') ? this.global.userID : '00000000-0000-0000-0000-000000000000') +
        "&filterPaneEnabled=False&rdl:parameterPanel=hidden";
      // let embedReportId = this.configurationservice.configuration.RPReportId;
      let config = {
        type: "report",
        tokenType: pbi.models.TokenType.Aad,
        accessToken: token[0],
        // embedUrl: embedUrl,
        // id: embedReportId,
        settings: {},
        viewmode: pbi.models.ViewMode.View,
      };
      let reportContainer = this.reportContainer.nativeElement;
      let powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      );
      let report = powerbi.embed(reportContainer, config);
      report.off("loaded");
      report.on("loaded", () => { });
    });
  }
  generateLastDateReport() {
    let currentTime = this.datepipe.transform(new Date(), "MM/dd/yyyy hh:mm a");
    this.ViewReport = true;
    this.reptitle = "Last Date Of Service Report";
    this.CommonAPI.CommonFunctionforPowerBiToken().then((token) => {
      document.getElementById("OpenCBirthDayModal").click();
      let embedUrl =
        "https://app.powerbi.com/rdlEmbed?reportId=" +
        this.environmentServicedata.LastDateOfServiceReportId +
        "&rp:ExecTime=" +
        currentTime +
        "&rp:agencyid=" +
        this.global.globalAgencyId +
        "&rp:locationid=" +
        ((this.locationId != null && this.locationId != undefined && this.locationId != '00000000-0000-0000-0000-000000000000') ? this.locationId : '') +
        "&rp:userid=" +
        ((this.global.userID != null && this.global.userID != undefined && this.global.userID != '00000000-0000-0000-0000-000000000000') ? this.global.userID : '') +
        "&filterPaneEnabled=False&rdl:parameterPanel=hidden";
      let embedReportId = this.environmentServicedata.LastDateOfServiceReportId;
      let config = {
        type: "report",
        tokenType: pbi.models.TokenType.Aad,
        accessToken: token[0],
        embedUrl: embedUrl,
        id: embedReportId,
        settings: {},
        viewmode: pbi.models.ViewMode.View,
      };
      let reportContainer = this.reportContainer.nativeElement;
      let powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      );
      let report = powerbi.embed(reportContainer, config);
      report.off("loaded");
      report.on("loaded", () => { });
    });
  }
  inactiveClientrecord(){
    document.getElementById('openinactive').click();
    this.isClientReportInactive=true;
  }
  InactiveClientModal()
  {
    document.getElementById('openinactive').click();
    this.isClientReportInactive=false;
  }
sdprecordModal(){
  this.isSDPReportActive=true;
    document.getElementById('openSDPReportModal').click();
    //this.isClientReportInactive=true;
  }
  // Date Change Handler with 90-day validation
onReportDateChanged(event: any, fieldName: string, type: string): void {
  if (type === 'input') {
    const val = this.dateservice.inputFeildchange(event);
    if (val !== undefined) {
      if (fieldName === 'fromDate') {
        this.reportFromDate = val;
        this.validateDateRange();
      } else if (fieldName === 'toDate') {
        this.reportToDate = val;
        this.validateDateRange();
      }
    }
  } else if (type === 'date') {
    const val = this.dateservice.Datechange(event);
    if (val !== undefined) {
      if (fieldName === 'fromDate') {
        this.reportFromDate = val;
        this.validateDateRange();
      } else if (fieldName === 'toDate') {
        this.reportToDate = val;
        this.validateDateRange();
      }
    }
  }
}

// Validate Date Range - Maximum 90 days
validateDateRange(): void {
  if (!this.reportFromDate || !this.reportToDate) {
    return;
  }

  const fromDate = new Date(this.reportFromDate);
  const toDate = new Date(this.reportToDate);

  // Check if from date is greater than to date
  if (fromDate.getTime() > toDate.getTime()) {
    this.toastrService.error('From Date cannot be greater than To Date');
    this.reportToDate = '';
    return;
  }

  // Calculate difference in days
  const timeDifference = toDate.getTime() - fromDate.getTime();
  const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));

  // Check if difference is greater than 90 days
  if (daysDifference > 90) {
    console.log('Date range cannot exceed 90 days. Please select a range within 90 days.');
    this.toastrService.error('Date range cannot exceed 90 days');
    this.reportToDate = '';
    return;
  }
}


// Search SDP Report with API call
searchSDPReport(): void {
  // Validation: Check if dates are selected
  if (!this.reportFromDate || !this.reportToDate) {
    this.toastrService.error('Please select both From Date and To Date');
    return;
  }
console.log(this.reportFromDate);
console.log(this.reportToDate);
  const fromDate = new Date(this.reportFromDate);
  const toDate = new Date(this.reportToDate);

  // Validation: Check if from date is greater than to date
  if (fromDate.getTime() > toDate.getTime()) {
    this.toastrService.error('From Date cannot be greater than To Date');
    return;
  }

  // Validation: Check if date range exceeds 90 days
  const timeDifference = toDate.getTime() - fromDate.getTime();
  const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));

  if (daysDifference > this.maxDateRangeDays) {
    this.toastrService.error(
      `Date range cannot exceed ${this.maxDateRangeDays} days. Current range is ${daysDifference} days. Please adjust your dates.`
    );
    return;
  }

  // Call API to get report data
  this.getSDPReportList();
}

// Get SDP Report List from API
getSDPReportList(): void {
  // API endpoint
  const url = "api/Client/GetSDPEndDateReport";
  
  // Response data mapping
  const responseData = {
    result: "result",
    count: "count",
  };

  // Assign values to the request object
  this.GetSDPReportBO.fromdate = this.global.getDateTimeString(this.reportFromDate);
  this.GetSDPReportBO.todate = this.global.getDateTimeString(this.reportToDate);

  // Make API call
  this.SDPAPI.outputValues1(url, this.GetSDPReportBO, responseData, "");

  // Subscribe to the response
  let count = 0;
  this.sdpData.pipe(takeUntil(this.onDestroy$)).subscribe(
    (data: any) => {
      this.SDPReportList = data.result || [];
    },
    (error: any) => {
      this.toastrService.error('Error fetching SDP report data');
      console.error('SDP Report Error:', error);
    }
  );
}
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
    //......................................exportCaseWithPaginationCsv.....................................................
    exportSDPWithPaginationCsv() { 
    let SDate = this.reportFromDate;
    let EDate = this.reportToDate;
    this.GetSDPReportBO.fromdate = (SDate != null && SDate != undefined && SDate != "") ? this.global.getDateTimeString(SDate) : null

    this.GetSDPReportBO.todate = (EDate != null && EDate != undefined && EDate != "") ? this.global.getDateTimeString(EDate) : null     
        let url = "api/Client/ExportSDPEnddateReportCsv";
        this.CommonAPI.saveorUpdateFunctionFileSaver(this.GetSDPReportBO ,url, "SDPEndDateReport.csv");
       
    }
     exportSDPAll() {
    let SDate = this.reportFromDate;
    let EDate = this.reportToDate;
    this.GetSDPReportBO.fromdate = (SDate != null && SDate != undefined && SDate != "") ? this.global.getDateTimeString(SDate) : null

    this.GetSDPReportBO.todate = (EDate != null && EDate != undefined && EDate != "") ? this.global.getDateTimeString(EDate) : null
        let url = "api/Client/exportEndDateAllCsv";
        this.CommonAPI.saveorUpdateFunctionFileSaver(this.GetSDPReportBO, url, "SDPEndDateReportAll.csv")
      
    }
    clearSDPReport()
    {
   this.reportFromDate='';
   this.reportToDate='';
   this.SDPReportList =[]
  this.GetSDPReportBO = new GetSDPReportBO();
  if (this.sdpReportGrid) {
    this.sdpReportGrid.dataSource = [];
    this.sdpReportGrid.refresh();
  }
    }
    
  showSDPReportColumnChooser() {
    this.sdpReportGrid.columnChooserModule.openColumnChooser(500, -50); // give X and Y axis
  }
}

